import React from 'react';
import { Checkbox, Button } from 'antd';
import { Check, Pencil, X, Store, User, Clock } from 'lucide-react';
import { fmtVZ } from '../../../utils/timeUtils';
import { formatPriceName } from '../../../utils/priceName';
import AuditImageThumb from './AuditImageThumb';
import AuditFlagChips from './AuditFlagChips';
import { BarcodeIcon } from './AuditFlagChips';

export default function AuditReviewCard({ item, selected, onSelect, onEdit, onApprove, onReject, onRecordClick }) {
    const product = item?.product;
    const scan = item?.latestScan;

    return (
        <div
            className={`shelf-card h-full p-4 flex flex-col transition-colors ${
                selected ? 'border-primary-300 bg-primary-50/40' : 'hover:border-surface-300'
            }`}>
            <div className="flex gap-3">
                <Checkbox checked={selected} onChange={(e) => onSelect?.(product?._id, e.target.checked)} className="mt-0.5 self-start" />
                <AuditImageThumb record={scan || { imageCount: 0 }} size={64} onClick={scan?._id ? () => onRecordClick?.(scan) : undefined} />
                <div className="flex-1 min-w-0">
                    <h3 className="m-0 text-sm font-semibold text-surface-900 leading-snug line-clamp-2">{product ? formatPriceName(product) : '—'}</h3>
                    <div className="flex items-center gap-1.5 mt-1">
                        <BarcodeIcon barcodeMeta={product?.barcodeMeta} hasCatalogMatch />
                        <span className="text-xs text-surface-500 tabular-nums">{product?.code}</span>
                    </div>
                </div>
            </div>

            <div className="mt-3">
                <AuditFlagChips flags={item?.flags} barcodeMeta={product?.barcodeMeta} />
            </div>

            {scan && (
                <div className="mt-3 space-y-1 text-xs text-surface-500">
                    <div className="flex items-center gap-1.5 truncate">
                        <Store className="shrink-0 text-surface-400" />
                        <span className="truncate">{scan.store?.name || '—'}</span>
                    </div>
                    <div className="flex items-center gap-3">
                        <span className="flex items-center gap-1.5 truncate">
                            <User className="shrink-0 text-surface-400" />
                            <span className="truncate">{scan.auditor?.name || '—'}</span>
                        </span>
                        <span className="flex items-center gap-1.5 shrink-0 tabular-nums">
                            <Clock className="text-surface-400" />
                            {fmtVZ(scan.createdAt)}
                        </span>
                    </div>
                </div>
            )}

            <div className="mt-auto pt-4 flex flex-wrap items-center gap-2">
                <Button size="small" icon={<Check />} onClick={() => onApprove?.(product)}>
                    Aprobar
                </Button>
                <Button size="small" danger icon={<X />} onClick={() => onReject?.(product)}>
                    Rechazar
                </Button>
                <Button size="small" type="text" icon={<Pencil />} onClick={() => onEdit?.(product)} className="ml-auto">
                    Editar
                </Button>
            </div>
        </div>
    );
}
